module.exports = __webpack_public_path__ + "static/media/SplitEvenlyScreen.3281a343.png";